@import '../../theme/colors';

.modal {
  margin: auto;

  .container {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding: 14px 40px 10px 23px;
    background-color: $white;

    .exitButton {
      position: absolute;
      right: 8px;
      top: 8px;
      color: #595959;
      cursor: pointer;
    }

    .header {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      border-bottom: 1px solid $neutral-200;
      padding-bottom: 4px;

      .title {
        p {
          margin: 0;
        }
        .subtitle {
          font-family: var(--font-family__body);
          font-size: 12px;
          font-weight: 300;
          color: $neutral-600;
        }
        .mainTitle {
          font-family: var(--font-family__heading);
          font-weight: 600;
          font-size: 16;
          color: $neutral-600;
          margin-top: 4px;
          &.withoutSubtitle {
            margin-top: 20px;
          }
        }
      }
      .status {
        margin: 0;
        margin-right: 20px;
        span {
          display: inline-block;
        }
      }
    }
  }

  .content {
    flex: 1;
  }
}
